import { CommonModule } from '@angular/common'
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import { NgModule } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'

import { SharedModule } from 'primeng/api'
import { ButtonModule } from 'primeng/button'
import { CheckboxModule } from 'primeng/checkbox'
import { DatePickerModule } from 'primeng/datepicker'
import { InputNumberModule } from 'primeng/inputnumber'
import { InputTextModule } from 'primeng/inputtext'
import { MultiSelectModule } from 'primeng/multiselect'
import { RippleModule } from 'primeng/ripple'
import { SelectModule } from 'primeng/select'
import { TableModule } from 'primeng/table'
import { ToolbarModule } from 'primeng/toolbar'
import { TooltipModule } from 'primeng/tooltip'

import { ConfigureFiltersModule } from '@app/components/configure-filters/configure-filters.module'
import { ConfigureFiltersService } from '@app/components/configure-filters/configure-filters.service'
import { ErrorComponent } from '@app/components/generic/errors'
import { GlobalSearchService } from '@app/components/global-search/global-search.service'

import { GenericColumnComponent } from './generic-column'
import { GenericListComponent } from './generic-list'

@NgModule({
  exports: [
    GenericColumnComponent,
    GenericListComponent,
    ErrorComponent,
  ],
  imports: [CommonModule,
    FormsModule,
    SharedModule,
    TableModule,
    DatePickerModule,
    InputTextModule,
    SelectModule,
    CheckboxModule,
    MultiSelectModule,
    ButtonModule,
    ToolbarModule,
    RouterModule,
    RippleModule,
    InputNumberModule,
    ConfigureFiltersModule,
    TooltipModule, GenericListComponent,
    GenericColumnComponent,
    ErrorComponent,
  ],
  providers: [
    GlobalSearchService,
    ConfigureFiltersService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class GenericModule {}
